import { toast } from "sonner";
import { DoorOpen } from "lucide-react";
import { Label } from "@/components/ui/label";
import { errText } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const LANDINGS = [
  ["dashboard", "Dashboard", "Week board with today highlighted"],
  ["calendar", "Calendar", "Straight into the calendar"],
];
const VIEWS = [
  ["day", "Day"],
  ["week", "Week"],
  ["month", "Month"],
];

export const StartupSettings = () => {
  const { user, savePreferences } = useAuth();
  const prefs = user?.preferences || {};
  const landing = prefs.landing || "dashboard";
  const landingView = prefs.landing_view || "week";

  const save = (patch) =>
    savePreferences({ ...prefs, ...patch })
      .then(() => toast.success("Opening screen saved"))
      .catch((e) => toast.error(errText(e)));

  return (
    <section className="surface p-6 lg:p-8" data-testid="startup-section">
      <h2 className="text-base md:text-lg font-heading font-semibold inline-flex items-center gap-2">
        <DoorOpen className="h-5 w-5" /> When the app opens
      </h2>
      <p className="mt-2 text-sm text-muted-foreground">
        Choose the screen you land on after signing in.
      </p>

      <div className="mt-6 flex flex-wrap gap-2">
        {LANDINGS.map(([value, title, hint]) => (
          <button
            key={value}
            data-testid={`landing-option-${value}`}
            onClick={() => save({ landing: value })}
            className={`px-5 py-3 rounded-sm border text-left transition-colors duration-200 ${
              landing === value
                ? "bg-primary text-primary-foreground border-primary"
                : "border-border hover:bg-accent"
            }`}
          >
            <span className="block text-base font-semibold">{title}</span>
            <span className="block text-xs opacity-80">{hint}</span>
          </button>
        ))}
      </div>

      {landing === "calendar" ? (
        <div className="mt-6 space-y-3">
          <Label className="label-caps">Calendar opens on</Label>
          <div className="flex flex-wrap gap-2">
            {VIEWS.map(([value, title]) => (
              <button
                key={value}
                data-testid={`landing-view-${value}`}
                onClick={() => save({ landing_view: value })}
                className={`px-5 py-3 rounded-sm border text-base font-medium transition-colors duration-200 ${
                  landingView === value
                    ? "bg-primary text-primary-foreground border-primary"
                    : "border-border hover:bg-accent"
                }`}
              >
                {title}
              </button>
            ))}
          </div>
        </div>
      ) : null}
    </section>
  );
};
